// Migration RAG Dust (decision de Louka du 01/10) : Dust est la seule source des documents. L'app ne
// connait pas l'identifiant de l'espace commun (« Company Data », different dans chaque app) : elle
// demande /w/<espace>/espace-commun/<categorie> (Documents -> folder, Sites web -> website), et cette
// page va a la categorie de l'espace commun.
import { useWorkspace } from "@app/lib/auth/AuthContext";
import { useAppRouter, usePathParam } from "@app/lib/platform";
import { useSpaces } from "@app/lib/swr/spaces";
import { Spinner } from "@dust-tt/sparkle";
import { useEffect } from "react";

const CATEGORIES = new Set([
  "folder",
  "website",
  "managed",
  "actions",
  "triggers",
]);

export function VersEspaceCommun() {
  const owner = useWorkspace();
  const router = useAppRouter();
  const brute = usePathParam("categorie");
  const categorie = brute && CATEGORIES.has(brute) ? brute : "folder";
  const { spaces, isSpacesLoading } = useSpaces({
    workspaceId: owner.sId,
    kinds: ["global"],
  });
  const commun = spaces.find((s) => s.kind === "global") ?? spaces[0];
  const { replace } = router;

  useEffect(() => {
    if (!isSpacesLoading && commun) {
      void replace(
        `/w/${owner.sId}/spaces/${commun.sId}/categories/${categorie}`
      );
    }
  }, [isSpacesLoading, commun, categorie, owner.sId, replace]);

  return (
    <div className="flex h-full items-center justify-center">
      <Spinner />
    </div>
  );
}
